import { deserialize, serialize, inheritSerialization } from "cerialize";

import TableColumn from "./TableColumn";
import AppConfig from "../AppConfig";
import BaseUUIDEntity from "./BaseUUIDEntity";
import currency from "../util/filter/currency";

@inheritSerialization(BaseUUIDEntity)
export default class Merchant extends BaseUUIDEntity {

    @serialize
    @deserialize
    public nama: string = "";

    @serialize
    @deserialize
    public kode: string = "";

    @serialize
    @deserialize
    public pemilik: string = "";

    @serialize
    @deserialize
    public rekening: string = "";

    @serialize
    @deserialize
    public lokasi: string = "";

    @serialize
    @deserialize
    public description: string = "";

    @serialize
    @deserialize
    public last_saldo: number = 0;

    public namaFeedback() {
        return this.defaultPropertyFeedback('nama');
    }

    public kodeFeedback() {
        return this.defaultPropertyFeedback('kode');
    }

    public pemilikFeedback() {
        return this.defaultPropertyFeedback('pemilik');
    }

    public rekeningFeedback() {
        return this.defaultPropertyFeedback('rekening');
    }

    public lokasiFeedback() {
        return this.defaultPropertyFeedback('lokasi');
    }

    public descriptionFeedback() {
        return this.defaultPropertyFeedback('description');
    }

    public hasValid() {
        return this.namaFeedback().valid && this.kodeFeedback().valid && this.pemilikFeedback().valid &&
            this.rekeningFeedback().valid && this.lokasiFeedback().valid && this.descriptionFeedback().valid;
    }

    public table() {
        const {
            nama, kode, pemilik, rekening, lokasi, last_saldo
        } = this;
        const saldo = currency(last_saldo);
        return {
            nama, kode, pemilik, rekening, lokasi, saldo
        };
    }

    public static columnName(): Array<TableColumn> {
        const absensi = new Merchant().table();
        let keys = Object.keys(absensi);

        return keys.map((field: any) => {
            const tableColumn = new TableColumn();
            tableColumn.name = AppConfig.getVm().$t(`label.${field}`);

            return tableColumn;
        });
    }

}